export default {
  en: {
    ago: '{0} ago',
    currentMonth: 'Current month',
    created: 'Created on {0}',
    refreshed: 'Refreshed {0}',
    updated: 'Updated {0}',
  },
  es: {
    ago: 'hace {0}',
    currentMonth: 'Mes actual',
    created: 'Creado el {0}',
    refreshed: 'Refrescado {0}',
    updated: 'Actualizado {0}',
  },
  fr: {
    ago: 'il y a {0}',
    currentMonth: 'Mois courrant',
    created: 'Créé le {0}',
    refreshed: 'Mis à jour {0}',
    updated: 'Mis à jour {0}',
  },
}
